import { z } from 'zod';
import type { DeepUndefinedOrNull } from '@/types/partial';
import { PessoaSchema } from '@/features/pessoa/types/Pessoa';
import { IndicadorIe } from '@/types/enum';
import {
    FornecedorContaTipo,
    FornecedorPixChaveTipo,
    FornecedorTipo,
    FornecedorTransferenciaTipo,
} from './enum';

export const FornecedorSchema = z.object({
    for_agencia: z.string().nullable(),
    for_agencia_dv: z.string().nullable(),
    for_banco: z.string().nullable(),
    for_codigoindividual: z.number().nullable(),
    for_conta: z.string().nullable(),
    for_conta_documento: z.string().nullable(),
    for_conta_dv: z.string().nullable(),
    for_conta_tipo: z.enum(FornecedorContaTipo),
    for_conta_titular: z.string().nullable(),
    for_data_cadastro: z.string().nullable(),
    for_empresa_idpk: z.number(),
    for_financeiro_banco_idpk: z.number().nullable(),
    for_financeiro_categoria_idpk: z.number().nullable(),
    for_idpk: z.number(),
    for_indicadorie: z.enum(IndicadorIe).nullable(),
    for_marcadores: z.string().nullable(),
    for_pedido_minimo: z.number().nullable(),
    for_pessoa_idpk: z.number(),
    for_pix_chave: z.string().nullable(),
    for_pix_chave_tipo: z.enum(FornecedorPixChaveTipo).nullable(),
    for_produtorrural_af: z.enum(['S', 'N']).nullable(),
    for_site: z.string().nullable(),
    for_tipo: z.enum(FornecedorTipo),
    for_transferencia_tipo: z.enum(FornecedorTransferenciaTipo),
    for_ultima_alteracao: z.string().nullable(),
    pessoa: PessoaSchema,
});

export type Fornecedor = z.infer<typeof FornecedorSchema>;
export type FornecedorBody = DeepUndefinedOrNull<Fornecedor>;
